import { createFileRoute, redirect } from '@tanstack/react-router'

// Legacy URL. Bank card promos moved into the Marketing Suite as a tab
// (/admin/marketing/card-promos) — a quarterly config screen didn't earn a
// top-level sidebar slot next to POS and Reports. Kept as a redirect so
// existing bookmarks and the desktop fleet's cached links keep working;
// managers retain access via both paths in lib/staff-roles.ts.
export const Route = createFileRoute('/admin/card-promos')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/marketing/card-promos' })
  },
})
